/**
 * Schema introspection query. Currently it requests all types and their fields
 * with fine set of details for each of them.
 * Additional details:
 * - the type of the field is retrieved with four levels of nesting, because
 * the field might be, for example: `NOT_NULL`, `LIST`, `NOT_NULL`, `SCALAR`
 * aka `[Int!]!`.
 */
const getIntrospectionQuery = (serviceName: string): string =>
  `
    query ${serviceName}SchemaIntrospection {
      __schema {
        types {
          name
          kind
          ...Enums
          fields {
            ...Field
          }
        }
      }
    }

    fragment Enums on __Type {
      enumValues {
        name
      }
    }

    fragment Field on __Field {
      name
      args {
        name
      }
      type {
        name
        kind
        ofType {
          kind
          name
          ofType {
            kind
            name
            ofType {
              kind
              name
            }
          }
        }
      }
    }
  `;

/**
 * Builds GQL introspection request payload.
 *
 * @param {string} serviceName the name of the service for which the introspection will be executed
 * @returns payload for GQL introspection request
 */
export const buildIntrospectionRequestPayload = (serviceName: string): any => {
  return {
    operationName: `${serviceName}SchemaIntrospection`,
    query: getIntrospectionQuery(serviceName),
    variables: null
  };
}
